<docs>
  This list is in the bottom, contains buildings and panoramas
</docs>

<template>
  <div class="viewer-list">
    <buildings v-if="property.objectId" />
    <panoramas />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Buildings from './Buildings.vue'
import Panoramas from './Panoramas.vue'

export default {
  name: 'ViewerList',
  components: {
    Buildings,
    Panoramas
  },

  computed: {
    ...mapGetters([
      'property'
    ])
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/common/extends'
@import '~css/addon/main'

.viewer-list {
  @extend .flex-center-column
  position: relative
  width: 100%
  z-index: $viewer-list-z
  pointer-events: none

  @media (min-width: $response) {
    align-items: flex-start
  }

  > * {
    pointer-events: auto
  }
}
</style>
